import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, apiError } from "@/lib/api";

const shell =
  "flex min-h-screen items-center justify-center bg-slate-50 p-6";
const card = "w-full max-w-sm panel p-5";
const input =
  "mt-1 h-9 w-full rounded-sm border border-slate-300 bg-white px-2.5 text-[13px] outline-none transition-colors duration-150 focus:border-blue-500 focus:ring-1 focus:ring-blue-200";
const button =
  "mt-3 h-9 w-full rounded-sm bg-blue-600 text-[13px] font-semibold text-white transition-colors duration-150 hover:bg-blue-700 disabled:opacity-60";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMessage(data.message);
    } catch (err) {
      setError(apiError(err));
    }
    setBusy(false);
  };

  return (
    <div className={shell}>
      <form onSubmit={submit} className={card} data-testid="forgot-password-form">
        <h1 className="font-display text-lg font-semibold text-slate-900">Wachtwoord vergeten</h1>
        <p className="mt-1 text-[12px] text-slate-500">
          Vul je e-mailadres in. De herstellink wordt naar de serverlog geschreven zolang er geen
          e-mailprovider is gekoppeld.
        </p>
        <label className="label-xs mt-4 block">E-mailadres</label>
        <input
          type="email"
          required
          value={email}
          data-testid="forgot-email-input"
          onChange={(e) => setEmail(e.target.value)}
          className={input}
        />
        {message && (
          <div
            className="mt-3 rounded-sm border border-emerald-300 bg-emerald-50 px-2.5 py-2 text-[12px] text-emerald-800"
            data-testid="forgot-success"
          >
            {message}
          </div>
        )}
        {error && (
          <div className="mt-3 rounded-sm border border-red-300 bg-red-50 px-2.5 py-2 text-[12px] text-red-800">
            {error}
          </div>
        )}
        <button type="submit" disabled={busy} className={button} data-testid="forgot-submit-button">
          Herstellink aanvragen
        </button>
        <Link to="/login" className="mt-3 block text-center text-[12px] text-blue-700">
          Terug naar inloggen
        </Link>
      </form>
    </div>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      navigate("/login");
    } catch (err) {
      setError(apiError(err));
    }
    setBusy(false);
  };

  return (
    <div className={shell}>
      <form onSubmit={submit} className={card} data-testid="reset-password-form">
        <h1 className="font-display text-lg font-semibold text-slate-900">Nieuw wachtwoord</h1>
        <label className="label-xs mt-4 block">Herstel-token</label>
        <input
          value={token}
          required
          data-testid="reset-token-input"
          onChange={(e) => setToken(e.target.value)}
          className={input}
        />
        <label className="label-xs mt-3 block">Nieuw wachtwoord (min. 8 tekens)</label>
        <input
          type="password"
          minLength={8}
          required
          value={password}
          data-testid="reset-password-input"
          onChange={(e) => setPassword(e.target.value)}
          className={input}
        />
        {error && (
          <div className="mt-3 rounded-sm border border-red-300 bg-red-50 px-2.5 py-2 text-[12px] text-red-800">
            {error}
          </div>
        )}
        <button type="submit" disabled={busy} className={button} data-testid="reset-submit-button">
          Wachtwoord opslaan
        </button>
      </form>
    </div>
  );
}
